import React from 'react'
import { Box, Grid, GridItem, Stack, Text } from '@chakra-ui/react'
import Image from 'next/image'
import ourStoryHeader from '@images/our-story-header.png'
import BrandOfJml from '@components/brand-of-jml'
import HeadingTag from '@components/heading-tag'

const OurStoryHeader = () => {
  return (
    <Box bg={'bg'} pt={10}>
      <HeadingTag
        style={{ textAlign: 'center', marginBottom: '50px' }}
        data-aos="fade-down"
      >
        Our Story
      </HeadingTag>
      <Box
        position="relative"
        pb={{
          lg: 36
        }}
      >
        <Grid templateColumns="repeat(12, 1fr)">
          <GridItem
            colSpan={{
              lg: 6,
              base: 12
            }}
            alignItems="center"
            display="flex"
            pb={16}
            pt={{
              lg: 16
            }}
            data-aos="fade-right"
          >
            <Grid templateColumns="repeat(12, 1fr)" w="100%">
              <GridItem
                colStart={{
                  lg: 2,
                  base: 1
                }}
                colEnd={{
                  lg: 12,
                  base: 13
                }}
                px={4}
              >
                <Box gap={4}>
                  <Box>
                    <Text textStyle="ourStoryTitleMedium">
                      Enlivening Happy Habitats.
                    </Text>
                    <Text textStyle="ourStoryTitleMedium" my={0}>
                      That’s what we do.
                    </Text>
                  </Box>
                  <Text textStyle="ourStoryTitle" mt={10}>
                    Brand Profile
                  </Text>
                  <Stack gap={4} mt={5}>
                    <Text textStyle="ourStoryText">
                      Welcome to Habbit. We are the knowledge bearers to
                      simplifying your life with innovative home solutions. We
                      are the happy movement, the cradle of living good,
                      inspiring everyday simplicity and wellness from the moment
                      you wake up, till you go to bed. Reshaping everyday
                      living, we bring innovative home solutions to turn daily
                      chores to happy habits.
                    </Text>
                    <Text textStyle="ourStoryText">
                      From Kitchenware, Home, Cleaning, Fitness and Health &
                      Beauty products, we have a Habbit for every home. We
                      believe everyone deserves a happy habitat and we are here
                      to do just that.
                    </Text>

                    <BrandOfJml />
                  </Stack>
                </Box>
              </GridItem>
            </Grid>
          </GridItem>

          <GridItem
            colSpan={{
              lg: 6,
              base: 12
            }}
            position="relative"
            minH="100%"
            style={{
              aspectRatio: '980/640'
            }}
            data-aos="fade-left"
          >
            <Image
              src={ourStoryHeader}
              alt="Enlivening Happy Habitats. That’s what we do."
              fill
              sizes="100vw"
              style={{
                objectFit: 'cover'
              }}
              priority
            />
          </GridItem>
        </Grid>
      </Box>
    </Box>
  )
}

export default OurStoryHeader
